module.exports = __webpack_public_path__ + "static/media/emptyCards.c989daab.svg";